import { ArrowUpRight } from "lucide-react";
import { LINKS } from "../data/content";
import { Reveal } from "./Reveal";
import { FacebookIcon, InstagramIcon, WhatsAppIcon } from "./icons";

const SOCIALS = [
  {
    testId: "social-instagram-logo-link",
    label: "INSTAGRAM",
    handle: "@drmugdhhashomoeopathy",
    href: LINKS.instagram,
    Icon: InstagramIcon,
  },
  {
    testId: "social-facebook-logo-link",
    label: "FACEBOOK",
    handle: "Gentle Cure Homoeoclinic",
    href: LINKS.facebook,
    Icon: FacebookIcon,
  },
  {
    testId: "connect-banner-whatsapp-btn",
    label: "WHATSAPP",
    handle: "+91 88501 59361",
    href: LINKS.whatsapp,
    Icon: WhatsAppIcon,
  },
];

const ConnectBanner = () => (
  <section id="contact" data-testid="global-connect-banner" className="relative bg-[#061D1F] py-20 sm:py-28 overflow-hidden">
    <div className="absolute inset-0 pointer-events-none opacity-[0.06]">
      <div className="absolute left-1/3 top-0 bottom-0 w-px bg-[#2DD4BF]" />
      <div className="absolute left-2/3 top-0 bottom-0 w-px bg-[#2DD4BF]" />
    </div>
    <div className="max-w-7xl mx-auto px-5 sm:px-8 relative">
      <Reveal>
        <p className="text-xs font-mono uppercase tracking-[0.25em] text-[#2DD4BF] mb-6">CONNECT / CONSULT / HEAL</p>
        <h2
          data-testid="connect-banner-title"
          className="text-2xl sm:text-3xl lg:text-4xl font-display font-semibold text-[#F8FAF8] tracking-tight"
        >
          Begin your gentle cure
        </h2>
        <p className="mt-4 text-sm sm:text-base text-[#F8FAF8]/60 leading-relaxed max-w-xl">
          One message is all it takes — reach out on WhatsApp for appointments, or follow the journey on social media.
        </p>
      </Reveal>

      <div className="mt-12 grid sm:grid-cols-3 gap-4">
        {SOCIALS.map((s, i) => (
          <Reveal key={s.label} delay={i * 0.08}>
            <a
              data-testid={s.testId}
              href={s.href}
              target="_blank"
              rel="noopener noreferrer"
              className="group flex items-center justify-between gap-4 border border-[#2DD4BF]/20 bg-[#2DD4BF]/[0.04] p-6 hover:bg-[#2DD4BF]/[0.1] hover:border-[#2DD4BF]/50 transition-colors duration-500"
            >
              <span className="flex items-center gap-4">
                <span className="flex items-center justify-center w-11 h-11 rounded-full border border-[#2DD4BF]/30 text-[#2DD4BF] group-hover:bg-[#2DD4BF] group-hover:text-[#061D1F] transition-colors duration-500">
                  <s.Icon className="w-5 h-5" />
                </span>
                <span>
                  <span className="block text-[10px] font-mono tracking-[0.22em] text-[#2DD4BF]">{s.label}</span>
                  <span className="block text-sm text-[#F8FAF8]/80 mt-1.5 break-all">{s.handle}</span>
                </span>
              </span>
              <ArrowUpRight className="w-4 h-4 text-[#2DD4BF]/50 group-hover:text-[#2DD4BF] group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-[transform,color] duration-300 shrink-0" />
            </a>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.25} className="mt-16 overflow-hidden">
        <p className="text-outline-dark font-display font-bold text-[16vw] sm:text-[13vw] leading-none tracking-tight text-center select-none">
          GENTLE CURE
        </p>
      </Reveal>
    </div>
  </section>
);

export default ConnectBanner;
